"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WechatAppletsLoginRequest = void 0;
var WechatAppletsLoginRequest = /** @class */ (function () {
    function WechatAppletsLoginRequest() {
    }
    return WechatAppletsLoginRequest;
}());
exports.WechatAppletsLoginRequest = WechatAppletsLoginRequest;
;
//# sourceMappingURL=wechatAppletsLogin.request.js.map